import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import languageManager from '../../../../services/languageManager'

import { Form, Input, InputNumber, Select, Switch, Divider } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

const PaymentMethodForm = (props) => {
    const [layout, setLayout] = useState(props.layout)
    // const [customerId, setCustomerId] = useState(props.customerId)
    const [values, setValues] = useState(props.values)

    const [form] = Form.useForm()
    const { Option } = Select

    useEffect(() => {
        console.log(props)
        // setCustomerId(props.customerId)
        setValues(props.values)
        if (_.isEmpty(props.values)) {
            form.resetFields()
        } else {
            form.setFieldsValue(props.values)
        }
    }, [props.values])

    const submitForm = (values) => {
        // values.customer_id = customerId
        props.submitForm(values)
    }

    return (
        <Form
            form={form}
            {...layout}
            id="PaymentMethodForm"
            onFinish={submitForm}
        >
            <Form.Item
                label="Nome"
                name="name"
                rules={[{ required: true, message: 'Inserisci un nome identificativo per il metodo di pagamento' }]}
            >
                <Input />
            </Form.Item>
            <Divider />
            <Form.Item
                label="Ritardo incasso"
                name="payment_delay"
            >
                <InputNumber
                    step={1}
                    min={0}
                    max={360}
                    addonAfter="giorni"
                />
            </Form.Item>
            <Form.Item
                label="Incasso a fine mese"
                name="end_of_month"
                valuePropName="checked"
            >
                <Switch
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                />
            </Form.Item>
            <Form.Item
                label="Incasso al giorno esatto"
                name="exact_day_of_month"
            >
                <InputNumber
                    step={1}
                    min={0}
                    max={31}
                    addonAfter="del mese"
                />
            </Form.Item>
            <Form.Item name="id" noStyle><Input type="hidden" /></Form.Item>
        </Form>
    )
}

const mapStateToProps = state => {
    return {
        commonState: state.commonState,
    }
}

export default connect(mapStateToProps)(PaymentMethodForm)